import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from 'react-redux';
import footer_logo from "web/assets/images/1footer_logo.svg";
import LinkedIn from "web/assets/images/in.svg";
import Twitter from "web/assets/images/x_twitter_new logo_icon.png";
import Facebook from "web/assets/images/facebook.png";
import { Container, Wrapper } from "./FooterStyled";

const LandingFooter = () => {
  const storedData = useSelector((state) => state.storedData.payload);
  const userType = storedData?.data?.userRole;
  const buyerEnums = new Set(['BUYER', 'BUYSELL', 'BROKER']);
  const sellerEnums = new Set(['SELLER', 'BUYSELL', 'BROKER']);
  const guestEnums = new Set(['GUEST']);
  const isBuyer = buyerEnums.has(userType);
  const isSeller = sellerEnums.has(userType);
  const isGuest = guestEnums.has(userType);

  return (
    <Container>
      <Wrapper>
        <div>
          <img className="mb-4" src={footer_logo} alt="logo" />
          <ul>
            {/* <li><NavLink to="/privacy-policy">PRIVACY</NavLink></li>
                        <li><NavLink to="/terms-of-use">TERMS OF USE</NavLink></li> */}
            <li>© {new Date().getFullYear()} Delancey Street Pallet Traders LLC</li>
            <li>© {new Date().getFullYear()} PalletTrader Managed Services LLC</li>
            <li>ALL RIGHTS RESERVED</li>
          </ul>
        </div>
        <div className="margin-top">
          <ul>
            {isSeller && <li><NavLink to="/nearby-needs">NEARBY NEEDS</NavLink></li>}
            {(isBuyer || isGuest) && <li><NavLink to="/nearby-inventory">NEARBY INVENTORY</NavLink></li>}
            {isBuyer && <li><NavLink to="/post-my-pallet-needs">POST NEEDS</NavLink></li>}
            {isSeller && <li><NavLink to="/post-my-pallet-inventory">POST INVENTORY</NavLink></li>}
          </ul>
        </div>
        <div className="margin-top">
          <ul>
            {isBuyer && <li><NavLink to="/my-posted-pallet-needs">MY POSTED NEEDS</NavLink></li>}
            {isSeller && <li><NavLink to="/my-posted-pallet-inventory">MY POSTED INVENTORY</NavLink></li>}
            {isSeller && <li><NavLink to="/view-my-bids-on-pallet-needs">MY BIDS ON NEEDS</NavLink></li>}
            {(isBuyer || isGuest) && <li><NavLink to="/view-my-offers-on-pallet-inventory">MY OFFERS ON INVENTORY</NavLink></li>}
          </ul>
        </div>
        <div className="margin-top">
          <ul>
            <li><NavLink to="/my-orders">MY ORDERS</NavLink></li>
            {(isBuyer || isSeller) && <li><NavLink to="/my-community">MY COMMUNITY</NavLink></li>}
            <li><NavLink to="/resolution-center">RESOLUTION CENTER</NavLink></li>
            <li><NavLink to="/order-reports">REPORTS</NavLink></li>
          </ul>
        </div>
        <div className="margin-top">
          <ul className="icons">
            <li><NavLink to="/operational-terms-and-conditions">OPERATIONAL T&C</NavLink></li>
            <li><NavLink to="/specifications">PALLET SPEC LIBRARY</NavLink></li>
            <li><a href="https://newsroom.pallettrader.com/" target="_blank">NEWSROOM</a></li>
            <li><a href="https://www.linkedin.com/company/pallettrader/jobs/" target="_blank">CAREERS</a></li>
            <li><a href="tel:+1-877-777-7495">1-877-777-7495</a></li>
            <li style={{ fontSize: '13px' }}><a href="mailto:support@pallettrader.com">support@pallettrader.com</a></li>
          </ul>
          <ul className="social-icons">
            <li>
              <a
                href="https://www.linkedin.com/company/pallettrader/"
                target="_blank"
              >
                <img src={LinkedIn} alt="icon" />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/Pallet_trader" target="_blank">
                <img src={Twitter} alt="icon" />
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/pallettraderdotcom/"
                target="_blank"
              >
                <img src={Facebook} alt="icon" />
              </a>
            </li>
          </ul>
        </div>
      </Wrapper>
    </Container>
  );
};

export default LandingFooter;
